<template>
<div id="contain">
  <div class="ui stackable ">
    <h4 class="ui dividing header">
      <i class="ui arrow left icon" v-on:click="goBack()" style="float: left;font-size: 25px;"></i>
      Paquetes dentro del armario
      <i class="ui window close outline icon" v-on:click="sessionClose()" style="float: right;font-size: 25px;"></i>
    </h4>
  
    <div v-if="searching" class="ui active centered inline loader"></div>
    <div v-else class="row">
      <div v-if="rows.length==0">
        No hay pedidos en el armario
      </div>
    
      <div v-else class="column">
        <DataTable :value="rows" responsiveLayout="stack">
          <Column field="id" hidden></Column>
          <Column field="parcel_id" hidden></Column>
          <Column field="name" header="Ref. pedido"></Column>
          <Column field="phone" header="Móvil"></Column>
          <Column field="amount" header="Importe"></Column>
          <Column field="multiorder_count" header="Nº cajones"></Column>
          <Column odyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-sign-out" @click="confirmOperout(slotProps.data.parcel_id, slotProps.data.multiorder_code, slotProps.data.multiorder_count)"></Button>
          </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</div>
</template>
<script>

export default {
  name: 'ParcelList',
  data() {
    return {
      msg: null,
      type: null,
      title: null,
      closeSession: 1,
      codError: null,
      show: true,
      parcels: null,
      searching: null,
      rows: [],
      apm: null,
      token: null,
    }
  },
  created() {
    this.token = localStorage.token;
    this.apm = localStorage.apm;
    this.hs = localStorage.virtualService_id;
    if (!this.token) {
      this.redirect(401,this.title,'','',this.token,this.closeSession);
    }

    this.getShipments(this.apm);
  },
  methods: {
    goBack(){
      this.$router.push({name: 'MenuService', params: {apm: this.apm, token: this.token, virtualServiceId: this.hs}});
    },
    sessionClose(){
      this.codError = '';
      this.msg = 'Carga de pedidos terminada.';
      this.type = 'success';
      this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
    },
    getShipments(apm){
      this.searching = true

      let url = this.$url_hapiick + "/v1/apms/inapt?apm="+apm;
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.get(url,{
        headers: headers
      })
      .then(request => {
        this.searching = false;

        this.rows=[]
        let parcels = []
        parcels = JSON.parse(JSON.stringify(request.data.shipmentsInApt))
        for (var i in parcels) {
          let element = parcels[i]
          this.rows.push({
            'name': element.name,
            'phone': element.phone,
            'parcel_id': element.parcel_id,
            'multiorder_code': element.multiorder_code,
            'multiorder_count': element.multiorder_count,
            'amount': element.amount,
            'id': element.id
          })
        }

        if (this.rows.length === 0) {
          this.otherAction();
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    confirmOperout(parcel_id, multiorder_code, multiorder_count) {
      let text = ''
      if (multiorder_count == 1) {
        text = 'Se va a abrir 1 puerta para retirar el pedido. Por favor, confirma la operación.'
      } else {
        text = 'Se van a abrir '+multiorder_count+' puertas para retirar el pedido. Por favor, confirma la operación.'
      }
      this.$swal({
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, quiero retirar el pedido',
        cancelButtonText: 'Cancelar operación'
      }).then((result) => {
        if (result.isConfirmed) {
          this.operout(parcel_id, multiorder_code)
        }
      })
    },
    operout(parcel_id, multiorder_code) {
      let url = this.$url_hapiick + '/v1/shipments/operout';
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': this.token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url, {
        apm: this.apm,
        parcel_id: parcel_id,
        multiorder_code: multiorder_code
      },{
        headers: headers
      })
      .then((request)  => {
        let seguir = false;
        if ('error' in request.data) {
          this.codError = request.data.error;
          if (this.codError == 500) {
            this.providerError = request.data.provider_error.message
            if (this.providerError === 'opened_slot') {
              this.$swal({
                icon: 'info',
                text: 'Para poder introducir el siguiente envió, por favor, asegurate de haber cerrado el cajon.',
              })
            } else if (this.providerError === 'system_exception') { //En este caso no haremos nada
              seguir = true;
            } else if (this.providerError ==='another_session_exists') {
              this.$swal({
                icon: 'info',
                text: 'Para poder retirar el siguiente envió, por favor, asegurate de haber cerrado el cajon.',
              })
            } else if (this.providerError === 'no_response_from_apm') {
              this.$swal({
                icon: 'error',
                title: 'ERROR INTERNO.',
                text: 'Por favor, vuelve a intentarlo. Si persiste el problema, ponte en contacto con nosotros a traves del teléfono 934 177 199. Disculpa las molestias. Gracias.',
              })
            } else {
              this.codError = '';
              this.type = 'error';
              this.title = 'OPERACIÓN CANCELADAA.';
              this.msg = 'Ponte en contacto a través del teléfono 934 177 199. Disculpa las molestias. Gracias.';
              this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
            }
          } else {
            this.msg = '';
            this.type = '';
            this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
          }
        } else {
          seguir = true;
        }

        if (seguir === true) {
          this.$swal({
            text: '¿Has retirado correctamente el paquete?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.isConfirmed) {
              let inapt = this.rows.filter(function(a) {
                return a.parcel_id != parcel_id 
              });
              this.rows = inapt
              if (this.rows.length === 0) {
                //no quedan paquetes por recoger en la máquina
                this.otherAction();
              }
            } else {
              this.$swal({
                icon: 'info',
                text: 'Vuelve a intentarlo. Si persite el problema, ponte en contacto con nosotros a través del teléfono 943 177 199. Disculpa las molestias. GRACIAS.',
              })
            }
          })
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    otherAction() {
      this.$swal({
        text: 'No hay pedidos pendientes por retirar. ¿Quieres realizar otra operación?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Si, volver al menu',
        cancelButtonText: 'No, cerrar sesion',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({name: 'MenuService'});
        } else {
          this.codError = '';
          this.msg = 'Retirada de pedidos terminada.';
          this.type = 'success';
          this.redirect(this.codError,this.title,this.msg, this.type,this.token,this.closeSession);
        }
      })
    },
    catchErrors(error){
      if(error.request) {
        if (error.request.status == 429) {
          this.codError = error.request.status
          this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
        } else {
          console.log(error.request)
        }
      }
    },
    redirect(codError, title, msg, type, token, closeSession) {  
      this.$router.push({name: 'Messages',params: {codError: codError, title: title, msg: msg, type:type, token:token, closeSession:closeSession}});
    }
  },
}
</script>

<style scoped>
#contain {
  margin: auto!important;
  width: 95%;
  height: 85%;
  position: absolute;
  top: 10%;
  left: 2.5%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

.p-button {
  background-color: #00f9a9!important;
  border-color: #00f9a9!important;
  color: black!important;
}

.ui.dividing.header, .ui.dividing.header .sub.header {
  padding-bottom: 0px!important;
}

.ui.dividing.header {
  border-bottom: 1px solid rgba(34,36,38,.15)!important;
  padding: 10px 5px 10px 5px!important
}
</style>
